import {interfaceStore} from "../stores/StoreLoader";
import {extractNumber} from "./StringUtilities";

export function sb_scrollWindowTo(loc) {
    if (loc === undefined) {
        loc = document.querySelector('html');
    }

    let offset = loc.getBoundingClientRect().top;

    if (loc.classList.contains('sb-block')) {
        offset = -200;
    }

    // Scroll to the top of the page after the drawer opens
    window.scroll({
        top: offset,
        behavior: "smooth",
    })
}

export function sb_velocityCloseRightDrawer() {
    var drawer = document.querySelector('.sb-right-drawer'),
        drawerOpenClass = 'open',
        mainContent = document.querySelector('#sb-content-canvas .sb-main-content');

    if (!drawer.classList.contains(drawerOpenClass)) {
        return;
    }

    mainContent.style.left = extractNumber(mainContent.style.left) - extractNumber(mainContent.getAttribute("data-shifted-left")) + "px";
    drawer.style.left = extractNumber(drawer.offsetLeft) + extractNumber(drawer.getAttribute("data-shifted-left")) + "px"
    drawer.style.visibility = "hidden";
    drawer.classList.remove(drawerOpenClass);
}

export function sb_velocityOpenRightDrawer() {
    var drawer = document.querySelector('.sb-right-drawer'),
        drawerSize = drawer.clientWidth,
        drawerOpenClass = 'open',
        mainContent = document.querySelector('#sb-content-canvas .sb-main-content'),
        mainContentRightBorder,
        shiftWidth,
        spacing = 10,
        travelDistance;

    if (drawer.classList.contains(drawerOpenClass)) {
        return;
    }
    mainContentRightBorder = mainContent.offsetLeft + mainContent.clientWidth;
    shiftWidth = drawerSize / 2;
    travelDistance = drawer.offsetLeft - mainContentRightBorder + shiftWidth - spacing;

    if(travelDistance < drawerSize) {
        shiftWidth += drawerSize - travelDistance;
        travelDistance = drawerSize;
    }

    mainContent.style.transition = "left 300ms ease";
    const mainContentShiftLeft = extractNumber(mainContent.style.left || "0px") - (shiftWidth + spacing);
    mainContent.setAttribute("data-shifted-left", mainContentShiftLeft);
    mainContent.style.left = mainContentShiftLeft + "px";

    drawer.style.transition = "left 300ms ease";
    const drawerContentShiftLeft = extractNumber(drawer.offsetLeft || "0px") - travelDistance;
    drawer.setAttribute("data-shifted-left", drawerContentShiftLeft);
    drawer.style.left = drawerContentShiftLeft + "px"
    drawer.style.visibility = "visible";
    drawer.classList.add(drawerOpenClass);
}

export function sb_hideAllAdminNavModals(exceptModal) {
    if (exceptModal !== 'editPage') {
        interfaceStore.stopEditingPage();
    }
}
